<template>
  <v-main>
    <router-view />
    <snackbar />
  </v-main>
</template>

<script>
export default {
  name: "DashboardCoreView",

  components: {
    snackbar: require("@/components/shared/Snackbar").default,
  },
};
</script>
